import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { CarePartnersService } from '../client'

export const useUpdatePatientCarePartner = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const updatePatientCarePartner = useCallback(
        async (patientId: string, carePartnerId: string) => {
            setLoading(true)
            setError(null)
            try {
                // Use the proper API client method for associating care partners with patients
                await CarePartnersService.associatePatientCarePartnersCarePartnerIdPatientPatientIdPost({
                    carePartnerId,
                    patientId
                })

                enqueueSnackbar('Care partner assigned successfully', { variant: 'success' })
                return { success: true }
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to assign care partner'
                setError(errorMessage)
                enqueueSnackbar(errorMessage, { variant: 'error' })
                throw err
            } finally {
                setLoading(false)
            }
        },
        [enqueueSnackbar]
    )

    return { loading, error, updatePatientCarePartner }
}
